// src/config.js

const config = {
    // apiBaseUrl: 'https://rangsakonass.in/api'
    apiBaseUrl: 'https://thegrowingtree.co.in/api'
    // apiBaseUrl: 'https://ehss.in/api'
    // apiBaseUrl: 'https://rsmss.in/api'
    // apiBaseUrl: 'https://vineyardschool.in/api'
    // apiBaseUrl: 'http://localhost/epro_API/api'
    // apiBaseUrl: 'https://rangsaparass.in/api'
  };
  
  export default config;